export enum CountriesEnum {
	"GR" = "GR",
	"IL" = "IL",
}

export const timezones = {
	GR: "Europe/Athens",
	IL: "Asia/Jerusalem",
};
